<svg [attr.width]="width" [attr.height]="height" [attr.viewBox]="'0 0 ' + width + ' ' + height">
  <polyline 
    [attr.points]="points"
    fill="none"
    stroke="steelblue"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"/>
</svg>
